import { render, staticRenderFns } from "./AllowedUserAuthContainer.vue?vue&type=template&id=bdaa6c36&"
import script from "./AllowedUserAuthContainer.vue?vue&type=script&lang=js&"
export * from "./AllowedUserAuthContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports